<script setup lang="ts">
import { useDisplay } from 'vuetify';

const { name } = useDisplay();
</script>

<template>
  <div class="bp">
    breakpoint: <b>{{ name }}</b>
  </div>
</template>

<style scoped lang="scss">
.bp {
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: #fff;
  padding: 0.5rem;
  border: 1px solid #000;
}
</style>
